<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeServices from '@/services/api/code.api'
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Entrevistas Realizadas (Detallado)',
      routes: ["Informes", "Entrevistas Realizadas (Detallado)"]
    },
    model: {
      search: {
        collections: {
          status: [],
          academicYears: [],
        },
        filters: {
          status: null,
          academicYears: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYears',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: 'col-md-6',
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYears,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        class: 'col-md-6',
        options: this.model.search.collections.status,
        value: this.model.search.filters.status,
      },
    ]},
  },
  async mounted() {
    this.setFilters();
  },
  methods: {
    async setFilters() {
      await CodeServices.GetQuestionnaireStatus()
        .then(res => this.model.search.collections.status = res.data);

      await AcademicYearServices.getStudentExitAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onHandlerSearch() {
     const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('detailedinterviewsconducted', {
          QuestionnaireStatusId: this.model.search.filters.status?.id,
          AcademicYearId: this.model.search.filters.academicYears.id,
        })
        .then(res => DocumentServices.Download(res.data))
    },
  },
}
</script>